import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import Store from './store/Store';
import { I18nextProvider } from 'react-i18next';
import i18n from './data/Lang';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import registerServiceWorker from './pwa/registerServiceWorker';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={Store}>
      <App />
      <ToastContainer />
    </Provider>
  </I18nextProvider>
);

reportWebVitals();
registerServiceWorker();
